<template>
<div class="order-box">
     <van-nav-bar
  title="全部订单"
  left-arrow
  @click-left="$router.go(-1)"
/>
<van-dropdown-menu>
  <van-dropdown-item v-model="orderType" :options="orderOption" />
</van-dropdown-menu>
<van-tabs v-model="active" @change="changeStatus">
  <van-tab title="全部"></van-tab>
  <van-tab title="待付款"></van-tab>
  <van-tab title="已付款"></van-tab>
  <van-tab title="已结算"></van-tab>
  <van-tab title="已失效"></van-tab>
</van-tabs>
<div class="tips">下单后订单同步需要一分钟，请耐心等待</div>
<div v-for="item in orderList"
:key="item.Id"
@click="$router.push('/pdd/detail?id='+item.goods_id)">
<van-card 
  :price="item.order_amount/100"
  :title="item.goods_name"
  :num="'佣金：'+(item.promotion_amount/100)+'元'"
  :thumb="item.goods_thumbnail_url"
>
  <template #tags>
    <van-tag plain type="danger">{{item.order_status_desc}}}</van-tag>
  </template>
</van-card>
</div>

<van-empty v-if="orderList.length === 0" description="暂无数据" />

</div> 
</template>


<script>
export default {
    data(){
      return{
        active: 0,
        status:'', //订单状态
        orderList:[],
        page:1,
        total:10,
        orderType: 'pdd',// 订单类型
        orderOption:[
           { text: '拼多多', value: 'pdd' },
           { text: '苏宁易购', value: 'sunning' },
        ],
      }
    },
    created(){
      this.getOrderList();
      this.statusOption ={
        0:'',
        1:'-1',
        2:'',
        3:'3',
        4: '',
      }
    },
    watch:{
      orderType(){
         this.getOrderList();
      },
    },
    methods:{
      changeStatus(){
        this.status = this.statusOption[this.active] || ''
         this.getOrderList()
      },
      getOrderList(){
        this.Post({
            status:this.status,
        },`/${this.orderType}/order`, res => {
            if (res.states == 1) {
                this.orderList=res.data.list || [];
                this.total=res.data.total || 1;
                this.page=res.data.page || 1;
            }else{
                this.orderList=[]
            }
        });
      },
    }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
.order-box{
   .tips{
     padding: 10px;
     color: #ff976a;
     background: rgba(248, 230, 172, 0.5);
   }
}
</style>


// WEBPACK FOOTER //
// src/pages/mine/order.vue